import { Union } from "../../fable_modules/fable-library-js.4.19.0/Types.js";
import { union_type } from "../../fable_modules/fable-library-js.4.19.0/Reflection.js";

export class DashboardPage extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Dashboard"];
    }
}

export function DashboardPage_$reflection() {
    return union_type("Bfs.Web.Kundenportal.WebParts.User.DashBoardPage.DashboardPage", [], DashboardPage, () => [[]]);
}

//# sourceMappingURL=DashBoardPage.fs.js.map
